/**
 * Erreurs communes pour les lectures contacts/candidats
 */

import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

export const CONTACT_PERSONS_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.CONTACT_PERSON_QUERY_INVALID]: {
        messageKey: 'an-error-occurred',
        severity: 'error',
    },
    [ERROR_CODES.CONTACT_PERSON_NOT_FOUND]: {
        messageKey: 'unable-to-retrieve-the-entity-from-boond',
        severity: 'error',
    },
};
